import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SxProps,
} from '@mui/material';
import { useField } from 'formik';

export interface FormikSelectOption<TId = string> {
  id: TId;
  displayName: string;
  hidden?: boolean;
  disabled?: boolean;
}

export interface FormikSelectFieldProps {
  name: string;
  label: string;
  required?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  onActive?: (active: boolean) => void;
  sx?: SxProps;
  options: FormikSelectOption[];
  helperText?: string;
}

export const FormikSelectField = (props: FormikSelectFieldProps) => {
  const [field, meta] = useField(props.name);
  const hasError = meta.touched && Boolean(meta.error);
  return (
    <FormControl sx={props.sx}>
      <InputLabel id={`select-${props.label}`} required={props.required}>
        {props.label}
      </InputLabel>

      <Select
        id={props.name}
        labelId={`select-${props.label}`}
        name={props.name}
        label={props.label}
        required={props.required}
        fullWidth={props.fullWidth ?? true}
        value={field.value}
        onChange={field.onChange}
        onBlur={(e) => {
          field.onBlur(e);
          if (props.onActive) props?.onActive(false);
        }}
        onFocus={() => {
          if (props.onActive) props.onActive(true);
        }}
        error={hasError}
        disabled={props.disabled}
        autoComplete={props.autoComplete ?? 'off'}
      >
        {props.options
          ?.filter((option) => !option.hidden)
          .map((option) => (
            <MenuItem
              id={`option-${option.id}`}
              key={option.id}
              value={option.id}
              disabled={option.disabled}
            >
              {option.displayName}
            </MenuItem>
          ))}
      </Select>

      {(props.helperText || hasError) && (
        <FormHelperText error={hasError}>
          {hasError ? meta.error : props.helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
